"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dashboard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const hooks_1 = require("../shared/hooks");
const icons_1 = require("../atoms/icons");
const notification_actions_1 = require("../molecules/notification-actions");
const Dashboard = ({ children, tabs, onBack, notificationActions }) => {
    const { isMobile } = (0, hooks_1.useRWD)();
    return ((0, jsx_runtime_1.jsxs)(Container, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [isMobile && ((0, jsx_runtime_1.jsx)(notification_actions_1.NotificationActions, { notifications: notificationActions }, void 0)), isMobile && tabs] }, void 0), (0, jsx_runtime_1.jsx)("div", { children: isMobile && ((0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", icon: ["far", "arrow-left"], size: "lg", onClick: onBack }, void 0)) }, void 0), children] }, void 0));
};
exports.Dashboard = Dashboard;
const Container = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.silverLighten40};

  position: relative;

  & > div:first-of-type {
    background-color: ${({ theme }) => theme.colors.whiteBase};
    margin-top: 0;
  }

  & > div:nth-of-type(2) > div {
    margin: ${({ theme }) => theme.spacings.m};
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    padding: 0;
  }
`;
//# sourceMappingURL=DashboardTemplate.js.map